<template>
  <el-dialog
    :visible.sync="arbitrationVisible"
    :show-close="false"
    :close="back"
    :width="IS_MOBILE?'90%':'1000px'"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
    v-if="arbitrationVisible"
  >
  <div class="arbitration-dialog">
      <div class="arbitration-dialog-title" @click="back">
        <i class="el-icon-arrow-left"></i>
        <span class="arbitration-dialog-back">Back</span>
      </div>
      <div class="arbitration-dialog-text">
        If the two parties cannot reach an agreement, you can initiate platform arbitration to intervene in the process
      </div>
      <div class="arbitration-dialog-description">
        <span>Arbitration Description</span>
        <div>
          <el-input type="textarea" v-model="arbitrationDes"></el-input>
        </div>
        <div style="color:red;margin-bottom:20px" v-if="!arbitrationDes">Please Enter Arbitration Description</div>
      </div>
      <div class="arbitration-dialog-description">
        <span>Submit Arbitration Credentials</span>
        <div><img-swiper :edit="true" ref="imgSwiper" :maxLength="30"></img-swiper></div>
      </div>
      <div class="arbitration-dialog-button">
      <div @click="back">Cancel</div>
      <div class="arbitration-dialog-button-application" @click="sumbit" >Submit arbitration</div>
    </div>
  </div>
  </el-dialog>
</template>

<script>
import imgSwiper from './img-swiper.vue'
import { postAction } from '@/api/manage.js'
export default {
  components: {imgSwiper},
  props: {
    serviceOrderId: {
      default: '',
      type: String
    },
    arbitrationVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IS_MOBILE: false,
      arbitrationDes: ''
    }
  },
  methods: {
    back() {
      this.arbitrationDes = ''
      this.$emit('backArbitrationVisible')
    },
    sumbit() {
      if (!this.arbitrationDes) {
        return
      }
      postAction(`/order/api/v0.2/service-orders/after-sale/arbitration`, {
        serviceOrderId: this.serviceOrderId,
        arbitrationDes: this.arbitrationDes,
        imgList: this.$refs['imgSwiper']['imgList']
      }).then((res) => {
        if (res.code === 200) {
          // 成功
          this.$emit('loadData')
          this.back()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@media screen and (max-width: 1024px) {
  .arbitration-dialog{
    padding: 15px !important;
  }
  .arbitration-dialog-button{
    padding: 10px 5px !important;
    div{
      width: 45% !important;
    }
  }
}
.arbitration-dialog{
  padding: 30px;
  font-family: Satoshi;
  color: #262613;
  .arbitration-dialog-title{
    color: #262B2F;
    display: flex;
    align-items: center;
    cursor: pointer;
    i{
      font-size: 16px;
    }
    span{
      padding-left: 5px;
    }
  }
}
.arbitration-dialog-text{
  padding: 20px 0;
}
.arbitration-dialog-description{
  font-family: Satoshi-bold;
  span{
    display: block;
     padding-bottom: 8px;
  }
}
.arbitration-dialog-button{
    display: flex;
    padding: 20px 33px;
    justify-content: center;
    div{
        width: 202px;
        height: 40px;
        border: 1px solid #262613;
        opacity: 1;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #262613;
        cursor: pointer;
      }
      .arbitration-dialog-button-application{
        background: #262613;
        color: #FFFFFF;
        margin-left: 20px;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/arbitration-dialog.vue